import { Button } from '../../components';
import React from 'react';
import { SubAdminManagementService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchAdminList: any;
  setShowOverlay: any;
}

const SubAdminManagementDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchAdminList,
    setShowOverlay,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const deleteDomesService = () => {
    setShowOverlay(true);
    SubAdminManagementService.deleteAdmin({
      adminId: id,
    }).then(() => {
      setShowOverlay(false);
      setDeleted(true);
    });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete Sub Admin
          </h2>
          <p>
            Are you sure you want to delete this Sub admin?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteDomesService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Sub admin deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchAdminList({
              page: 1,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default SubAdminManagementDelete;
